import Dashboard2 from 'views/Admin/Dashboard/index.tsx';
import { DashboardType } from 'views/Admin/Dashboard/types';
import { getReleaseNotesLabel } from 'views/Admin/ReleaseNotes/helper.js';
import CompanyConfiguration from 'views/Company/Configuration/';
import CVESubscription from 'views/CVE/Subscription';
import Findings from 'views/Findings/';
import { SourceType, sourceTypeConfig } from 'views/Findings/state.ts';
import MembersListing from 'views/Members/index';
import PCFindings from 'views/PCFindings/';
import { ReportList } from 'views/Reports/List.jsx';
import SAST2 from 'views/sast2/index.tsx';
import UserProfile from 'views/UserProfile.jsx';

import { ReleaseNoteList } from './views/Admin/ReleaseNotes/List.jsx';
import GuestsCAInstallationInstructions from './views/CAInstallationInstructions/guests';
import CAInstallationInstructions from './views/CAInstallationInstructions/index';
import NotFound from './views/Errors/NotFound';
import { ScanList } from './views/Scans/List';

function getGuestRoutes() {
  let releaseNoteLabel = getReleaseNotesLabel();
  var guestRoutes = [
    {
      path: '/dashboard',
      name: 'Dashboard',
      icon: 'tim-icons icon-chart-pie-36',
      // sidebar: false,
      component: Dashboard2,
      layout: '/client',
    },
    {
      path: '/vulnerabilities',
      name: 'Vulnerabilities',
      fullName: 'Vulnerabilities',
      icon: 'fa fa-bug',
      component: Findings,
      layout: '/client',
    },
    {
      path: `/dashboard#${DashboardType.CA}`,
      name: 'Cloud Agents',
      icon: sourceTypeConfig[SourceType.CA].iconClass,
      component: Dashboard2,
      layout: '/client',
    },
    {
      path: `/dashboard#${DashboardType.EP}`,
      name: 'Endpoints',
      icon: sourceTypeConfig[SourceType.EP].iconClass,
      component: Dashboard2,
      layout: '/client',
    },
    {
      path: `/dashboard#${DashboardType.WAS}`,
      name: 'Web Apps',
      icon: sourceTypeConfig[SourceType.WAS].iconClass,
      component: Dashboard2,
      layout: '/client',
    },
    {
      // NOTE: this component is not listed in left menu and excluded
      path: '/sast',
      name: 'SAST_Add_Repos',
      fullName: 'STATIC APP SECURITY TESTING (SAST)',
      icon: sourceTypeConfig[SourceType.SAST].iconClass,
      component: SAST2,
      layout: '/client',
    },
    {
      path: `/dashboard#${DashboardType.SAST2}`,
      name: 'SAST',
      fullName: 'STATIC APP SECURITY TESTING (SAST)',
      icon: sourceTypeConfig[SourceType.SAST].iconClass,
      component: Dashboard2,
      layout: '/client',
    },
    {
      path: `/dashboard#${DashboardType.PC}`,
      name: 'Policy Compliance (beta)',
      fullName: 'Policy Compliance',
      icon: 'fas fa-shield-alt',
      component: Dashboard2,
      layout: '/client',
    },
    {
      path: '/pc-findings',
      name: 'PC Findings (beta)',
      fullName: 'Policy Compliance Findings',
      icon: 'fa fa-clipboard-list',
      component: PCFindings,
      layout: '/client',
    },
    {
      path: '/cve',
      name: 'CVE Subscriptions',
      fullName: 'CVE Subscriptions',
      icon: 'fa fa-bell',
      component: CVESubscription,
      layout: '/client',
    },
    // {
    //   path: "/bpr",
    //   name: "CLOUD BPA",
    //   fullName: "Best Practice Assessment (BPA)",
    //   icon: "BP",
    //   component: BPR,
    //   layout: "/client"
    // },
    {
      path: '/user-profile',
      name: 'User Profile',
      icon: 'tim-icons icon-single-02',
      component: UserProfile,
      sidebar: false,
      layout: '/client',
    },
    {
      path: '/settings',
      name: 'Settings',
      icon: 'tim-icons icon-single-02',
      component: CompanyConfiguration,
      sidebar: false,
      layout: '/client',
    },
    {
      path: '/qualys/reports',
      name: 'Reports',
      icon: 'tim-icons icon-bullet-list-67',
      component: ReportList,
      layout: '/client',
    },
    {
      path: '/qualys/scans',
      name: 'Scans',
      icon: 'fa fa-qrcode',
      sidebar: false,
      component: ScanList,
      layout: '/client',
    },
    {
      path: '/members',
      name: 'Members',
      icon: 'fa fa-users',
      component: MembersListing,
      layout: '/client',
    },
    {
      path: '/404',
      name: '404',
      icon: 'tim-icons icon-single-02',
      component: NotFound,
      sidebar: false,
      layout: '/client',
    },
    {
      path: '/product/notes',
      name: releaseNoteLabel,
      icon: 'tim-icons icon-notes',
      component: ReleaseNoteList,
      layout: '/client',
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      icon: 'tim-icons icon-chart-pie-36',
      // sidebar: false,
      component: Dashboard2,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/vulnerabilities',
      name: 'Vulnerabilities',
      fullName: 'Vulnerabilities',
      icon: 'fa fa-bug',
      component: Findings,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/qualys/cloud_agents/installation_instructions',
      name: 'Installation Instructions',
      icon: 'CA',
      component: GuestsCAInstallationInstructions,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/qualys/cloud_agents/new_installation_instructions',
      name: 'Installation Instructions',
      icon: 'CA',
      component: CAInstallationInstructions,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/sast',
      name: 'SAST',
      fullName: 'STATIC APP SECURITY TESTING (SAST)',
      icon: 'SS',
      component: SAST2,
      sidebar: false,
      layout: '/guest',
    },
    // {
    //   path: "/bpr",
    //   name: "CLOUD BPA",
    //   fullName: "Best Practice Assessment (BPA)",
    //   icon: "BP",
    //   component: BPR,
    //   sidebar: false,
    //   layout: "/guest"
    // },
    {
      path: '/user-profile',
      name: 'User Profile',
      icon: 'tim-icons icon-single-02',
      component: UserProfile,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/settings',
      name: 'Settings',
      icon: 'tim-icons icon-single-02',
      component: CompanyConfiguration,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/qualys/reports',
      name: 'Reports',
      icon: 'tim-icons icon-bullet-list-67',
      component: ReportList,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/qualys/scans',
      name: 'Scans',
      icon: 'fa fa-qrcode',
      sidebar: false,
      component: ScanList,
      layout: '/guest',
    },
    {
      path: '/members',
      name: 'Members',
      icon: 'fa fa-users',
      component: MembersListing,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/404',
      name: '404',
      icon: 'tim-icons icon-single-02',
      component: NotFound,
      sidebar: false,
      layout: '/guest',
    },
    {
      path: '/product/notes',
      name: releaseNoteLabel,
      icon: 'tim-icons icon-notes',
      component: ReleaseNoteList,
      sidebar: false,
      layout: '/guest',
    },
  ];

  return guestRoutes;
}

export default getGuestRoutes;
